const csvData =`
admit,gre,gpa,ses,Gender_Male,Race,rank
0,380,3.61,1,0,3,3
1,660,3.67,2,0,2,3
1,800,4,2,0,2,1
1,640,3.19,1,1,2,4
0,520,2.93,3,1,2,4
1,760,3,2,1,1,2
1,560,2.98,2,1,2,1
0,400,3.08,2,0,2,2
1,540,3.39,1,1,1,3
0,700,3.92,1,0,2,2
0,800,4,1,1,1,4
0,440,3.22,3,0,2,1
1,760,4,3,1,2,1
0,700,3.08,2,0,2,2
1,700,4,2,1,1,1
0,480,3.44,3,0,1,3
0,780,3.87,2,0,3,4
0,360,2.56,3,1,3,3
0,800,3.75,1,1,3,2
1,540,3.81,1,0,3,1
0,500,3.17,3,0,2,3
1,660,3.63,1,0,1,2
0,600,2.82,1,0,3,4
0,680,3.19,1,0,1,4
1,760,3.35,2,0,2,2
1,800,3.66,2,1,1,1
1,620,3.61,2,0,1,1
1,520,3.74,2,0,3,4
1,780,3.22,1,0,1,2
0,520,3.29,1,0,1,1
0,540,3.78,1,1,1,4
0,760,3.35,2,1,1,3
0,600,3.4,3,0,1,3
1,800,4,3,0,1,3
0,360,3.14,1,1,2,1
0,400,3.05,3,0,2,2
0,580,3.25,1,0,2,1
0,520,2.9,2,0,2,3
1,500,3.13,2,0,2,2
1,520,2.68,2,0,1,3
0,560,2.42,1,1,3,2
1,580,3.32,1,0,1,2
1,600,3.15,2,1,1,2
0,500,3.31,2,0,2,3
0,700,2.94,1,0,3,2
1,460,3.45,2,1,3,3
1,580,3.46,3,1,1,2
0,500,2.97,3,0,2,4
0,440,2.48,3,0,3,4
0,400,3.35,3,0,1,3
0,640,3.86,2,1,3,3
0,440,3.13,2,0,2,4
0,740,3.37,2,1,3,4
1,680,3.27,2,0,2,2
0,660,3.34,1,0,1,3
1,740,4,1,1,2,3
0,560,3.19,3,1,1,3
0,380,2.94,3,0,2,3
0,400,3.65,3,1,2,2
0,600,2.82,3,1,1,4
1,620,3.18,2,1,1,2
0,560,3.32,1,0,3,4
0,640,3.67,1,1,2,3
1,680,3.85,1,1,3,3
0,580,4,2,1,3,3
0,600,3.59,1,0,1,2
0,740,3.62,3,1,2,4
0,620,3.3,2,1,3,1
0,580,3.69,3,0,3,1
0,800,3.73,1,1,1,1
0,640,4,1,1,1,3
0,300,2.92,1,1,1,4
0,480,3.39,2,0,2,4
0,580,4,3,0,3,2
0,720,3.45,2,1,2,4
0,720,4,2,0,3,3
0,560,3.36,1,1,2,3
1,800,4,3,0,3,3
0,540,3.12,3,1,2,1
1,620,4,2,0,2,1
0,700,2.9,2,0,2,4
0,620,3.07,3,1,2,2
0,500,2.71,2,0,3,2
0,380,2.91,3,1,2,4
1,500,3.6,1,1,1,3
0,520,2.98,2,0,2,2
0,600,3.32,1,0,3,2
0,600,3.48,1,0,1,2
0,700,3.28,3,0,3,1
1,660,4,1,1,1,2
0,700,3.83,2,0,2,2
1,720,3.64,2,0,2,1
0,800,3.9,3,1,1,2
0,580,2.93,3,1,1,2
1,660,3.44,2,0,3,2
0,660,3.33,2,1,3,2
0,640,3.52,2,1,3,4
0,480,3.57,3,1,2,2
0,700,2.88,2,1,3,2
0,400,3.31,3,1,2,3
0,340,3.15,2,0,1,3
0,580,3.57,1,1,2,3
0,380,3.33,3,0,3,4
0,540,3.94,3,0,1,3
1,660,3.95,2,1,1,2
1,740,2.97,1,1,1,2
1,700,3.56,1,1,2,1
0,480,3.13,2,0,1,2
0,400,2.93,1,1,3,3
0,480,3.45,3,0,1,2
0,680,3.08,3,0,3,4
0,420,3.41,2,1,3,4
0,360,3,1,0,1,3
0,600,3.22,3,1,2,1
0,720,3.84,1,1,2,3
0,620,3.99,2,1,2,3
1,440,3.45,1,1,3,2
0,700,3.72,2,1,2,2
1,800,3.7,1,0,2,1
0,340,2.92,3,1,2,3
1,520,3.74,2,0,2,2
1,480,2.67,1,0,1,2
0,520,2.85,3,0,1,3
0,500,2.98,3,0,2,3
0,720,3.88,2,0,3,3
0,540,3.38,3,0,3,4
1,600,3.54,3,0,3,1
0,740,3.74,1,0,3,4
0,540,3.19,1,1,3,2
0,460,3.15,3,0,2,4
1,620,3.17,1,0,3,2
0,640,2.79,3,1,1,2
0,580,3.4,3,0,1,2
0,500,3.08,2,1,2,3
0,560,2.95,3,1,1,2
0,500,3.57,2,1,3,3
0,560,3.33,3,1,2,4
0,700,4,3,1,1,3
0,620,3.4,3,0,1,2
1,600,3.58,3,0,3,1
0,640,3.93,2,1,2,2
1,700,3.52,2,0,1,4
0,620,3.94,3,0,2,4
0,580,3.4,2,1,3,3
0,580,3.4,1,1,1,4
0,380,3.43,2,0,1,3
0,480,3.4,1,1,3,2
0,560,2.71,3,1,1,3
1,480,2.91,3,1,1,1
0,740,3.31,3,0,1,1
1,800,3.74,3,0,1,1
0,400,3.38,2,1,1,2
1,640,3.94,3,1,1,2
0,580,3.46,3,1,1,3
0,620,3.69,3,0,1,3
1,580,2.86,3,1,1,4
0,560,2.52,3,0,3,2
1,480,3.58,1,1,1,1
0,660,3.49,2,0,3,2
0,700,3.82,2,1,1,3
0,600,3.13,1,1,1,2
0,640,3.5,2,0,1,2
1,700,3.56,3,1,2,2
0,520,2.73,1,0,1,2
0,580,3.3,1,0,3,2
0,700,4,2,1,3,1
0,440,3.24,3,1,3,4
0,720,3.77,3,0,2,3
0,500,4,3,0,2,3
0,600,3.62,1,1,3,3
0,400,3.51,3,1,1,3
0,540,2.81,3,0,1,3
0,680,3.48,3,0,3,3
1,800,3.43,1,0,3,2
0,500,3.53,1,1,1,4
1,620,3.37,3,1,1,2
0,520,2.62,1,1,2,2
1,620,3.23,3,1,2,3
0,620,3.33,3,0,3,3
0,300,3.01,2,0,1,3
0,620,3.78,3,0,2,3
0,500,3.88,1,0,2,4
0,700,4,1,1,3,2
1,540,3.84,1,0,3,2
0,500,2.79,1,0,2,4
0,800,3.6,1,1,2,2
0,560,3.61,2,0,3,3
0,580,2.88,3,1,3,2
0,560,3.07,2,1,2,2
0,500,3.35,2,1,3,2
1,640,2.94,1,0,2,2
0,800,3.54,1,0,2,3
0,640,3.76,2,0,2,3
0,380,3.59,1,1,1,4
1,600,3.47,1,0,2,2
0,560,3.59,1,1,1,2
0,660,3.07,1,0,3,3
1,400,3.23,1,0,3,4
0,600,3.63,2,0,3,3
0,580,3.77,3,1,2,4
0,800,3.31,1,0,3,3
1,580,3.2,2,0,2,2
1,700,4,3,0,3,1
0,420,3.92,1,0,3,4
1,600,3.89,1,0,2,1
1,780,3.8,3,0,2,3
0,740,3.54,2,0,1,1
1,640,3.63,3,1,1,1
0,540,3.16,3,0,2,3
0,580,3.5,3,0,1,2
0,740,3.34,2,0,2,4
0,580,3.02,3,1,2,2
0,460,2.87,1,0,3,2
0,640,3.38,1,0,1,3
1,600,3.56,3,0,1,2
1,660,2.91,2,0,2,3
0,340,2.9,1,0,1,1
1,460,3.64,3,1,3,1
0,460,2.98,2,1,3,1
1,560,3.59,2,0,2,2
0,540,3.28,2,1,2,3
0,680,3.99,2,1,3,3
1,480,3.02,1,0,3,1
0,800,3.47,1,0,3,3
0,800,2.9,2,1,2,2
1,720,3.5,1,0,1,3
0,620,3.58,1,0,2,2
0,540,3.02,3,0,1,4
0,480,3.43,1,0,1,2
1,720,3.42,3,0,2,2
0,580,3.29,1,1,3,4
0,600,3.28,1,1,2,3
0,380,3.38,1,0,3,2
0,420,2.67,3,1,3,3
1,800,3.53,3,0,1,1
0,620,3.05,2,1,1,2
1,660,3.49,2,1,1,2
0,480,4,2,1,2,2
0,500,2.86,1,0,2,4
0,700,3.45,2,0,2,3
0,440,2.76,2,0,3,2
1,520,3.81,2,0,2,1
1,680,2.96,2,1,1,3
0,620,3.22,3,0,3,2
0,540,3.04,1,1,1,1
0,800,3.91,3,1,2,3
0,680,3.34,3,0,1,2
0,440,3.17,3,0,3,2
0,680,3.64,2,1,3,3
0,640,3.73,2,1,1,3
0,660,3.31,2,1,2,4
0,620,3.21,1,0,3,4
1,520,4,2,1,1,2
1,540,3.55,3,1,3,4
1,740,3.52,2,0,1,4
0,640,3.35,1,0,2,3
1,520,3.3,1,0,1,2
1,620,3.95,1,0,1,3
0,520,3.51,2,1,1,2
0,640,3.81,2,1,3,2
0,680,3.11,2,1,1,2
0,440,3.15,1,1,3,2
1,520,3.19,1,1,1,3
1,620,3.95,3,0,3,3
1,520,3.9,2,1,3,3
0,380,3.34,3,0,2,3
0,560,3.24,2,1,1,4
1,600,3.64,1,0,3,3
1,680,3.46,2,0,3,2
0,500,2.81,3,1,3,3
1,640,3.95,3,1,3,2
0,540,3.33,3,1,1,3
1,680,3.67,3,0,3,2
0,660,3.32,1,1,2,1
0,520,3.12,3,0,1,2
1,600,2.98,1,1,2,2
0,460,3.77,2,0,3,3
1,580,3.58,3,1,2,1
1,680,3,2,1,1,4
1,660,3.14,2,1,2,2
0,660,3.94,2,1,1,2
0,360,3.27,1,1,3,3
0,660,3.45,3,0,2,4
0,520,3.1,2,1,2,4
1,440,3.39,3,0,3,2
0,600,3.31,2,1,3,4
1,800,3.22,1,1,3,1
1,660,3.7,1,1,1,4
0,800,3.15,2,1,1,4
0,420,2.26,2,1,2,4
1,620,3.45,3,0,3,2
0,800,2.78,1,0,2,2
0,680,3.7,2,1,1,2
0,800,3.97,2,0,1,1
0,480,2.55,2,0,2,1
0,520,3.25,2,0,1,3
0,560,3.16,3,0,2,1
0,460,3.07,2,0,2,2
0,540,3.5,2,1,3,2
0,720,3.4,2,0,1,3
0,640,3.3,2,1,3,2
1,660,3.6,2,0,1,3
1,400,3.15,3,0,3,2
1,680,3.98,3,1,1,2
0,220,2.83,1,1,3,3
0,580,3.46,1,0,1,4
1,540,3.17,1,0,1,1
0,580,3.51,1,1,1,2
0,540,3.13,2,1,3,2
0,440,2.98,2,0,3,3
0,560,4,1,0,3,3
0,660,3.67,2,0,1,2
0,660,3.77,2,0,3,3
1,520,3.65,2,1,2,4
0,540,3.46,1,0,3,4
1,300,2.84,3,1,1,2
1,340,3,2,0,3,2
1,780,3.63,1,1,1,4
1,480,3.71,2,1,1,4
0,540,3.28,1,1,3,1
0,460,3.14,1,0,2,3
0,460,3.58,2,0,1,2
0,500,3.01,1,1,2,4
0,420,2.69,2,1,1,2
0,520,2.7,1,1,1,3
0,680,3.9,3,1,2,1
0,680,3.31,3,0,2,2
1,560,3.48,1,1,3,2
0,580,3.34,1,0,1,2
0,500,2.93,2,0,2,4
0,740,4,2,0,1,3
0,660,3.59,1,0,3,3
0,420,2.96,2,1,2,1
0,560,3.43,2,0,2,3
1,460,3.64,2,0,3,3
1,620,3.71,3,0,1,1
0,520,3.15,1,0,3,3
0,620,3.09,3,0,2,4
0,540,3.2,2,1,1,1
1,660,3.47,2,1,2,3
0,500,3.23,3,0,1,4
1,560,2.65,1,0,3,3
0,500,3.95,2,0,1,4
0,580,3.06,1,1,1,2
0,520,3.35,3,0,2,3
0,500,3.03,2,0,2,3
0,600,3.35,3,1,1,2
0,580,3.8,1,1,3,2
0,400,3.36,3,0,1,2
0,620,2.85,1,0,2,2
1,780,4,3,1,3,2
0,620,3.43,3,0,2,3
1,580,3.12,1,0,2,3
0,700,3.52,3,0,3,2
1,540,3.78,1,0,3,2
1,760,2.81,2,1,2,1
0,700,3.27,2,0,2,2
0,720,3.31,3,1,2,1
1,560,3.69,1,0,3,3
0,720,3.94,3,1,3,3
1,520,4,1,0,1,1
1,540,3.49,1,1,3,1
0,680,3.14,1,1,1,2
0,460,3.44,2,1,3,2
1,560,3.36,1,0,1,1
0,480,2.78,3,0,1,3
0,460,2.93,1,1,1,3
0,620,3.63,2,1,2,3
0,580,4,1,0,2,1
0,800,3.89,3,0,1,2
1,540,3.77,3,0,1,2
1,680,3.76,1,1,2,3
1,680,2.42,1,1,1,1
1,620,3.37,3,1,1,1
0,560,3.78,1,1,3,2
0,560,3.49,3,0,1,4
0,620,3.63,3,1,2,2
1,800,4,2,0,3,2
0,640,3.12,2,1,1,3
0,540,2.7,2,1,1,2
0,700,3.65,1,0,3,2
1,540,3.49,3,1,1,2
0,540,3.51,3,1,3,2
0,660,4,1,1,3,1
1,480,2.62,2,1,1,2
0,420,3.02,1,1,3,1
1,740,3.86,3,0,2,2
0,580,3.36,3,1,2,2
0,640,3.17,2,0,2,2
0,640,3.51,3,1,3,2
1,800,3.05,1,1,3,2
1,660,3.88,1,0,1,2
1,600,3.38,3,0,3,3
1,620,3.75,2,0,2,2
1,460,3.99,3,1,3,3
0,620,4,2,0,2,2
0,560,3.04,2,0,1,3
0,460,2.63,3,0,2,2
0,700,3.65,1,1,1,2
0,600,3.89,2,1,3,3
`
export default csvData